(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dl-campaign-films"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dl-campaign-film')) {
  customElements.define('dl-campaign-film', class extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      if (!this.video) return;
      this.video.muted = true;
      this.video.controls = false;
      this.video.removeAttribute('controls');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.visible = false;
      this.sync = () => {
        if (this.visible && !document.hidden && !this.motion.matches) {
          this.video.play().catch(() => {});
        } else {
          this.video.pause();
        }
      };
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].intersectionRatio >= 0.5;
        this.sync();
      }, { threshold: [0, 0.5] });
      this.observer.observe(this);
      document.addEventListener('visibilitychange', this.sync);
      this.motion.addEventListener('change', this.sync);
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      document.removeEventListener('visibilitychange', this.sync);
      this.motion?.removeEventListener('change', this.sync);
      this.video?.pause();
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
